import LoadingIcon from "Components/LoadingIcon";
import AppConfig from "Config/AppConfig";
import _ from "lodash";
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import styled from "styled-components";
import { Colors, Fonts } from "Themes";
import { FormError, FormSuccess } from "Themes/StyledComponents";

const ContentContainer = styled.div`
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  border: ${(props) => props.border && "solid 2px lightgray"};
  border-radius: 5px;
  height: 100%;
  overflow: auto;
  align-items: stretch;
  justify-content: center;
`;

const ResourceMainContainer = styled.div`
  display: flex;
  justify-content: flex-wrap;
  flex-wrap: wrap;
  flex: 3;
`;

const ResourceContainer = styled.div`
  border: ${(props) => (props.resourceAdded ? `solid 2px green` : `solid 0px`)};
  margin: 10px;
  padding: 5px;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: ${Fonts.primaryFontFamily}
  &:hover {
    border: solid 2px lightgray;
  }
`;

const ButtonContainer = styled.div`
  width: 50%;
  float: left;
  flex: 1;
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
`;

const UrlInput = styled.input`
  padding: 10px;
  border: ${(props) =>
    props.urlError ? "solid 2px red" : "solid 2px lightgray"};
  border-radius: 5px;
  margin: 5px;
  width: 100%;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const AddedResourcesContainer = styled.div`
  padding: 10px;
  margin: 2.5px;
  width: 100%;
  display: flex;
  justify-content: flex-wrap;
  // border-bottom: solid 2px gray;
`;

const ResourceIconContainer = styled.div`
  background-color: white;
  border: solid 2px ${Colors.successColor};
  border-radius: 20px;
  width: 100px;
  padding: 10px;
  margin: 0px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    border: solid 2px ${Colors.errorColor};
  }
`;

const CheckMark = styled(IoIosCheckmarkCircleOutline)`
  cursor: pointer;
  margin-right: 5%;
  &:hover {
    color: green;
  }
`;

const ResourceImage = styled.img`
  height: 30px;
  width: 30px;
  border-radius: 30px;
`;

class AddResourceForm extends Component {
  state = {
    showModal: false,
    resource: {},
    privateDefault: true,
    addedResources: [],
    resourceUrl: "",
    urlError: false,
    stage: 1,
  };

  async componentDidMount() {
    const { addedResources } = this.props;
    if (addedResources) {
      const formattedResources = addedResources.map((resource) => {
        return {
          id: resource.resource.id,
          name: resource.resource.resourceName,
          url: resource.resourceLink,
          private: true,
        };
      });
      this.setState({
        addedResources: formattedResources,
      });
    }
  }

  openModal = (resource) => {
    this.setState({
      showModal: true,
      resource: resource,
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
      resourceUrl: "",
      urlError: false,
    });
  };

  addResource = () => {
    const { resource, addedResources, resourceUrl } = this.state;
    const resourceData = {
      id: resource.id,
      name: resource.resourceName,
      url: resourceUrl,
      private: true,
    };

    if (resourceUrl.length === 0) {
      this.setState({
        urlError: true,
      });
      return;
    }

    const resourceIndex = _.findIndex(addedResources, function(r) {
      return r.id === resource.id;
    });
    if (resourceIndex > -1) {
      return;
    }
    this.setState((prevState) => ({
      showModal: false,
      resourceUrl: "",
      urlError: false,
      addedResources: [...prevState.addedResources, resourceData],
    }));
  };

  removeResource = (resource) => {
    const { addedResources } = this.state;
    const newResources = addedResources.filter(
      (index) => index.id !== resource.id
    );
    this.setState({
      showModal: false,
      resourceUrl: "",
      addedResources: newResources,
    });
  };

  onChangeUrl = ({ target: { value } }) => {
    this.setState({
      resourceUrl: value,
    });
  };

  handleResourceSubmit = () => {
    const { addedResources } = this.state;
    this.props.handleSubmit(addedResources);
  };

  render() {
    const {
      resources,
      border,
      fetching,
      error,
      success
    } = this.props;
    const { showModal, resource, addedResources, urlError } = this.state;

    const CustomIcon = AppConfig.NoProfilePic;

    const resourceExists =
      _.findIndex(addedResources, function(r) {
        return r.id === resource.id;
      }) > -1;

    return (
      <>
        <ContentContainer border={border}>
          <Modal show={showModal} onHide={this.handleClose}>
            <Modal.Header>{resource.resourceName}</Modal.Header>
            <Modal.Body>
              <UrlInput
                onChange={(e) => this.onChangeUrl(e)}
                placeholder={"URL (e.g. https://mywebsite.com)"}
                urlError={urlError}
              />
              {urlError && <p style={{ color: "red" }}>Required</p>}
            </Modal.Body>
            <Modal.Footer>
              <IconContainer>
                {!resourceExists && (
                  <CheckMark fontSize={35} onClick={this.addResource} />
                )}
              </IconContainer>
            </Modal.Footer>
          </Modal>
          <AddedResourcesContainer>
            {addedResources.length === 0 && (
              <div style={{ fontFamily: Fonts.primaryFontFamily }}>
                You don't have any links. Click on a link to add it.
              </div>
            )}
            {addedResources.map((resource, key) => {
              return (
                <ResourceIconContainer
                  key={key}
                  onClick={() => this.removeResource(resource)}
                >
                  {resource.name}
                  <MdClose />
                </ResourceIconContainer>
              );
            })}
          </AddedResourcesContainer>

          <ResourceMainContainer>
            {resources.map((resource, key) => (
              <ResourceContainer
                key={key}
                onClick={() => this.openModal(resource)}
              >
                {resource.resourceName === "Website" ? (
                  <CustomIcon
                    size={30}
                    style={{ border: "solid 2px lightgray", borderRadius: 30 }}
                  />
                ) : (
                  <ResourceImage src={resource.resourceImage} />
                )}
                {resource.resourceName}
              </ResourceContainer>
            ))}
          </ResourceMainContainer>
          {error && <FormError>{error}</FormError>}
          <ButtonContainer>
            <Button type={"submit"} onClick={this.handleResourceSubmit}>
              {fetching ? <LoadingIcon /> : "Save"}
            </Button>
          </ButtonContainer>
          {success && <FormSuccess>Links updated!</FormSuccess>}
        </ContentContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resources: ProjectSelectors.getResources(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getResources: () => dispatch(ProjectActions.getResourcesRequest()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddResourceForm);
